import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Link} from 'react-router-dom';

import Form from 'common/components/Form';
import Button from 'common/components/Button/Button';
import Input from 'common/components/Input/Input';

import { Urls } from 'django_js_control/reverse';

import './LoginForm.less';

import validate from './validate';

class LoginForm extends Component {

    render() {

        const {
            onSubmit,
            loginPending
        } = this.props;

        return (
            <Form className="LoginContainer-form"
                  form="login"
                  validate={validate}
                  onSubmit={onSubmit}>
                <Field component={Input}
                       label="E-mail"
                       name="email"
                       grow={true} />

                <Field component={Input}
                       label="Password"
                       name="password"
                       inputType="password"
                       grow={true} />

                <div className="LoginContainer-button">
                    <Button type="solid"
                            color="primary"
                            disabled={loginPending}
                            grow={true}>
                        Log In
                    </Button>
                </div>
                <div className="LoginContainer-linkContainer">
                    <Link className="LoginContainer-link" to={Urls['control:login:login']('forgot')}>Forgot your password?</Link>
                </div>
            </Form>
        );
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./assets/app/login/components/LoginForm/LoginForm.jsx